import { StyleSheet, View } from "react-native";
import NotificationBell from "../../svgs/common/NotificationBell";
import { useNotification } from "../../../contexts/NotificationContext";

export const NotificationIcon = () => {
  const { hasUnreadNotification } = useNotification();

  return (
    <View style={styles.iconWrapper}>
      <NotificationBell />
      {hasUnreadNotification && <View style={styles.notificationDot} />}
    </View>
  );
};

const styles = StyleSheet.create({
  iconWrapper: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  notificationDot: {
    position: "absolute",
    bottom: -3,
    right: -3,
    width: 8,
    height: 8,
    borderRadius: 5,
    backgroundColor: "#dd1111",
  },
});
